export enum CircleStepDisplayState {
  COMPLETED,
  ACTIVE,
  DISABLED,
}
